import { isoZ, z } from 'my-zod'

export const selectCreditEventTypeEnum = z.enum([
  'PAYMENT', // e.g. reservation
  'REFUND', // e.g. reservation cancellation
  'RENEWAL', // subscription renewal
  'SIGNUP BONUS', // bonus given for new subscription
  'MANUAL ADJUSTMENT', // customer service rep adjusts credits manually
  'PURCHASE', // e.g. a purchase of credits
  'RETURN', // e.g. a return or purchased credits
  'EXPIRE DUE TO CANCELLATION', // e.g. end of 90 days period after subscription cancellation
  'CREDIT SHARE ACTION (DEBITING)', // credit share debit event
  'CREDIT SHARE ACTION (CREDITING)', // credit share credit event
  'CREDIT MIGRATION'
])
export type CreditEventType = z.infer<typeof selectCreditEventTypeEnum>

export const selectCreditEventsSystemView = z.object({
  id: z.number(),
  memberShortId: z.string(),
  subscriptionCreditImpact: z.number(),
  createdDate: isoZ.instant(),
  eventType: selectCreditEventTypeEnum
})

export type selectCreditEventsSystemView = z.infer<typeof selectCreditEventsSystemView>
